module.exports = __webpack_public_path__ + "static/media/panel.33e50234.jpg";